import { AxiosInstance, AxiosPromise } from 'axios';
import { BulkResponse } from '@trukt/types/BulkResponse';

import {
  BulkJobLoadboardServicesEndpoint,
  BulkLoadboardRequest,
} from './BulkJobLoadboardServices.types';

export class BulkJobLoadboardServices implements BulkJobLoadboardServicesEndpoint {
  instance: AxiosInstance;
  constructor(instance: AxiosInstance) {
    this.instance = instance;
  }

  post(request: BulkLoadboardRequest): AxiosPromise<BulkResponse> {
    return this.instance.put('/bulk/loadboards/post', request.body);
  }

  unPost(request: BulkLoadboardRequest): AxiosPromise<BulkResponse> {
    return this.instance.put('/bulk/loadboards/unpost', request.body);
  }
}
